module.exports = __webpack_public_path__ + "static/media/gas-pump.ef31866d.svg";